import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const LMT_ENHCMT_getPrefferedOptions_API_CALL = createAsyncThunk(
  'LMT_ENHCMT_getPrefferedOptions_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    const {
      getPrefferedOptionsPayload,
      successFn = () => {},
      errorFn = () => {},
      finallyFn,
    } = payload;
    const { authorization, customerId, bankId } = getPrefferedOptionsPayload;
    dispatch({
      type: 'LMT_ENHCMT_getPrefferedOptions_API_CALL/pending',
      payload: {},
    });

    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'getprefferedoptionofbankfoeweb',
      payload: {
        customerId,
        bankId,
      },
      otherPayloadDetailsPresent: true,
      headers: { authorization, customerid: customerId },
      method: 'POST',
      successFn: (response) => {
        const bankPrefferedInfo =
          response && response.body && response.body.bankInfoDetails;
        dispatch({
          type: 'LMT_ENHCMT_getPrefferedOptions_API_CALL/fulfilled',
          payload: bankPrefferedInfo,
        });
        if (successFn) successFn(response);
      },
      errorFn: (err) => {
        dispatch({
          type: 'LMT_ENHCMT_getPrefferedOptions_API_CALL/rejected',
          payload: err,
        });
        if (errorFn) errorFn(err);
      },
      finallyFn,
    });
  }
);

export const LMT_ENHCMT_getPrefferedOptions_API_CALL_extrareducer = {
  [LMT_ENHCMT_getPrefferedOptions_API_CALL.pending]: (state, action) => {
    state.getPrefferedOptionsAPICall.isLoading = true;
  },
  [LMT_ENHCMT_getPrefferedOptions_API_CALL.fulfilled]: (state, action) => {
    state.getPrefferedOptionsAPICall.isLoading = false;
    state.getPrefferedOptionsAPICall.isSuccess = true;
    state.getPrefferedOptionsAPICall.isError = false;
    state.getPrefferedOptionsAPICall.response = action.payload;
  },
  [LMT_ENHCMT_getPrefferedOptions_API_CALL.rejected]: (state, action) => {
    state.getPrefferedOptionsAPICall.isLoading = false;
    state.getPrefferedOptionsAPICall.isSuccess = false;
    state.getPrefferedOptionsAPICall.isError = true;
    state.getPrefferedOptionsAPICall.response = action.payload;
  },
};
